var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { key: Math.random(), staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, loader: "dots" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("ValidationObserver", {
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit }) {
                    return [
                      _c("table", { staticClass: "table table-bordered" }, [
                        _c("thead", [
                          _c("tr", [
                            _c(
                              "th",
                              { staticClass: "title", attrs: { colspan: "4" } },
                              [_vm._v("任用單")]
                            ),
                          ]),
                        ]),
                        _c(
                          "tbody",
                          [
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "text-right",
                                  attrs: { colspan: "1" },
                                },
                                [_vm._v("應徵姓名")]
                              ),
                              _c("td", { attrs: { colspan: "3" } }, [
                                _vm._v(
                                  " " + _vm._s(_vm.appointment.Name) + " "
                                ),
                              ]),
                            ]),
                            _c("tr", [
                              _c("td", { staticClass: "width-15 text-right" }, [
                                _c("span", { staticClass: "mark" }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v("身份別 "),
                              ]),
                              _c(
                                "td",
                                { staticClass: "width-35" },
                                [
                                  _c("ValidationProvider", {
                                    attrs: {
                                      rules: "required",
                                      name: "身份別",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "el-select",
                                                {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    clearable: "",
                                                    placeholder: "請選擇",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.appointment
                                                        .IdentityType,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.appointment,
                                                        "IdentityType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "appointment.IdentityType",
                                                  },
                                                },
                                                [
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "IDL",
                                                      value: "IDL",
                                                      disabled:
                                                        _vm.$route.params
                                                          .Action === "special",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "IDL工讀生",
                                                      value: "IDL工讀生",
                                                      disabled:
                                                        _vm.$route.params
                                                          .Action === "special",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "DL",
                                                      value: "DL",
                                                      disabled:
                                                        _vm.$route.params
                                                          .Action === "special",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "按摩師",
                                                      value: "按摩師",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label:
                                                        "DL產學合作4+2產學生(高中畢業)",
                                                      value:
                                                        "DL產學合作4+2產學生(高中畢業)",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label:
                                                        "DL產學合作1年期實習生(大四學生)",
                                                      value:
                                                        "DL產學合作1年期實習生(大四學生)",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "外籍",
                                                      value: "外籍",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              errors[0]
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-danger ml-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c("td", { staticClass: "width-15 text-right" }, [
                                _c("span", { staticClass: "mark" }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v("薪制 "),
                              ]),
                              _c(
                                "td",
                                { staticClass: "width-35" },
                                [
                                  _c("ValidationProvider", {
                                    attrs: { rules: "required", name: "薪制" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-check form-check-inline",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.appointment
                                                            .SalaryType,
                                                        expression:
                                                          "appointment.SalaryType",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "radio",
                                                      id: "SalaryType1",
                                                      value: "時薪",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.appointment
                                                          .SalaryType,
                                                        "時薪"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.appointment,
                                                          "SalaryType",
                                                          "時薪"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label",
                                                      attrs: {
                                                        for: "SalaryType1",
                                                      },
                                                    },
                                                    [_vm._v(" 時薪 ")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-check form-check-inline",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.appointment
                                                            .SalaryType,
                                                        expression:
                                                          "appointment.SalaryType",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "radio",
                                                      id: "SalaryType2",
                                                      value: "月薪",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.appointment
                                                          .SalaryType,
                                                        "月薪"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.appointment,
                                                          "SalaryType",
                                                          "月薪"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label",
                                                      attrs: {
                                                        for: "SalaryType2",
                                                      },
                                                    },
                                                    [_vm._v(" 月薪 ")]
                                                  ),
                                                ]
                                              ),
                                              errors[0]
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-danger ml-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ]),
                            !(
                              _vm.appointment.ResumeType === "IDL" &&
                              _vm.appointment.SalaryType === "月薪"
                            )
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    { staticClass: "width-15 text-right" },
                                    [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v("錄用類型 "),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    { staticClass: "width-35" },
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          rules: "required",
                                          name: "錄用類型",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-check form-check-inline",
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.appointment
                                                                .EmployCategory,
                                                            expression:
                                                              "appointment.EmployCategory",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-check-input",
                                                        attrs: {
                                                          type: "radio",
                                                          id: "EmployCategory1",
                                                          value: "新人錄用",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm.appointment
                                                              .EmployCategory,
                                                            "新人錄用"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.appointment,
                                                              "EmployCategory",
                                                              "新人錄用"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "form-check-label",
                                                          attrs: {
                                                            for: "EmployCategory1",
                                                          },
                                                        },
                                                        [_vm._v("新人錄用")]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-check form-check-inline",
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.appointment
                                                                .EmployCategory,
                                                            expression:
                                                              "appointment.EmployCategory",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-check-input",
                                                        attrs: {
                                                          type: "radio",
                                                          id: "EmployCategory2",
                                                          value:
                                                            "老人回廠/舊年資併計",
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm.appointment
                                                              .EmployCategory,
                                                            "老人回廠/舊年資併計"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$set(
                                                              _vm.appointment,
                                                              "EmployCategory",
                                                              "老人回廠/舊年資併計"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "form-check-label",
                                                          attrs: {
                                                            for: "EmployCategory2",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " 老人回廠／舊年資併計 "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  errors[0]
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-danger ml-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "td",
                                    { staticClass: "width-15 text-right" },
                                    [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v("任用部門 "),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    { staticClass: "width-35" },
                                    [
                                      _c("ValidationProvider", {
                                        staticClass: "w-50",
                                        attrs: {
                                          name: "Plant",
                                          rules: "required",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticClass: "w-100",
                                                      attrs: {
                                                        filterable: "",
                                                        "allow-create": "",
                                                        clearable: "",
                                                        "value-key": "Guid",
                                                        placeholder: "Plant",
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          ;(_vm.deptOptions =
                                                            []),
                                                            (_vm.appointment.AppointmentDepartment =
                                                              null)
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.appointment
                                                            .AppointmentPlant,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.appointment,
                                                            "AppointmentPlant",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "appointment.AppointmentPlant",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.plantOptions,
                                                      function (plant) {
                                                        return _c("el-option", {
                                                          key: plant.Guid,
                                                          attrs: {
                                                            label: plant.Name,
                                                            value: plant,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                  errors[0]
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger ml-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _c("ValidationProvider", {
                                        staticClass: "w-50",
                                        attrs: {
                                          name: "Dept",
                                          rules: "required",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticClass: "w-100",
                                                      attrs: {
                                                        filterable: "",
                                                        clearable: "",
                                                        "allow-create": "",
                                                        "value-key": "Guid",
                                                        placeholder:
                                                          "請先選擇 Plant",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.appointment
                                                            .AppointmentDepartment,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.appointment,
                                                            "AppointmentDepartment",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "appointment.AppointmentDepartment",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.deptOptions,
                                                      function (dept) {
                                                        return _c("el-option", {
                                                          key: dept.Guid,
                                                          attrs: {
                                                            label: dept.Name,
                                                            value: dept,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                  errors[0]
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger ml-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _c("tr", [
                              _c("td", { staticClass: "width-15 text-right" }, [
                                _vm._v("最高學歷"),
                              ]),
                              _c("td", { staticClass: "width-35" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.appointment.HighestEducation) +
                                    " "
                                ),
                              ]),
                              _c("td", { staticClass: "width-15 text-right" }, [
                                _vm._v("學校／科系"),
                              ]),
                              _c("td", { staticClass: "width-35" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.appointment.School) +
                                    "／" +
                                    _vm._s(_vm.appointment.Department) +
                                    " "
                                ),
                              ]),
                            ]),
                            _c(
                              "tr",
                              [
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-right",
                                    attrs: { colspan: "1" },
                                  },
                                  [
                                    _c("span", { staticClass: "mark" }, [
                                      _vm._v("*"),
                                    ]),
                                    _vm._v("Offer 顯示單位 "),
                                  ]
                                ),
                                _c(
                                  "td",
                                  {
                                    attrs: {
                                      colspan: !(
                                        _vm.appointment.ResumeType === "IDL" &&
                                        _vm.appointment.SalaryType === "月薪"
                                      )
                                        ? 1
                                        : 3,
                                    },
                                  },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: "required",
                                        name: "Offer 顯示單位",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("el-input", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    disabled:
                                                      !_vm.$Permission
                                                        .Appointment
                                                        .DLPermission.IsValid,
                                                    clearable: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.appointment
                                                        .OfferDisplayDepartment,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.appointment,
                                                        "OfferDisplayDepartment",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "appointment.OfferDisplayDepartment",
                                                  },
                                                }),
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger ml-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                !(
                                  _vm.appointment.ResumeType === "IDL" &&
                                  _vm.appointment.SalaryType === "月薪"
                                )
                                  ? [
                                      _c(
                                        "td",
                                        { staticClass: "width-15 text-right" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _vm._v("報到日期 "),
                                        ]
                                      ),
                                      _c(
                                        "td",
                                        [
                                          _c("ValidationProvider", {
                                            attrs: {
                                              rules: "required",
                                              name: "報到日期",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("el-date-picker", {
                                                        staticClass: "w-100",
                                                        attrs: {
                                                          type: "date",
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          "picker-options": {
                                                            disabledDate:
                                                              _vm.$common
                                                                .disabledDateBeforeToday,
                                                          },
                                                          placeholder: "請選擇",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.appointment
                                                              .OnBoardTime,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.appointment,
                                                              "OnBoardTime",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "appointment.OnBoardTime",
                                                        },
                                                      }),
                                                      errors[0]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger ml-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "title",
                                  attrs: { colspan: "4" },
                                },
                                [_vm._v("任用建議")]
                              ),
                            ]),
                            _c(
                              "tr",
                              [
                                _c(
                                  "td",
                                  { staticClass: "width-15 text-right" },
                                  [
                                    _c("span", { staticClass: "mark" }, [
                                      _vm._v("*"),
                                    ]),
                                    _vm._v("職缺名稱 "),
                                  ]
                                ),
                                _c(
                                  "td",
                                  {
                                    attrs: {
                                      colspan: !(
                                        _vm.appointment.ResumeType === "IDL" &&
                                        _vm.appointment.SalaryType === "月薪"
                                      )
                                        ? 1
                                        : 3,
                                    },
                                  },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "職缺名稱",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      filterable: "",
                                                      clearable: "",
                                                      placeholder: "請選擇",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.appointment
                                                          .PositionCode,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.appointment,
                                                          "PositionCode",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "appointment.PositionCode",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.positionOptions,
                                                    function (position) {
                                                      return _c("el-option", {
                                                        key: position.Code,
                                                        attrs: {
                                                          label: position.Name,
                                                          value: position.Code,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger ml-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                !(
                                  _vm.appointment.ResumeType === "IDL" &&
                                  _vm.appointment.SalaryType === "月薪"
                                )
                                  ? [
                                      _c(
                                        "td",
                                        { staticClass: "width-15 text-right" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _vm._v("任用職稱 "),
                                        ]
                                      ),
                                      _c(
                                        "td",
                                        { staticClass: "width-35" },
                                        [
                                          _c("ValidationProvider", {
                                            attrs: {
                                              name: "任用職稱",
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticClass: "w-100",
                                                          attrs: {
                                                            disabled:
                                                              !_vm.$Permission
                                                                .Appointment
                                                                .DLPermission
                                                                .IsValid,
                                                            clearable: "",
                                                            placeholder:
                                                              "請選擇",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.appointment
                                                                .AppointmentPosition,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.appointment,
                                                                "AppointmentPosition",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "appointment.AppointmentPosition",
                                                          },
                                                        },
                                                        [
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "生產助理員",
                                                              value:
                                                                "生產助理員",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label: "助理",
                                                              value: "助理",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "技術助理員",
                                                              value:
                                                                "技術助理員",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label: "技術員",
                                                              value: "技術員",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "高級技術員",
                                                              value:
                                                                "高級技術員",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label: "事務員",
                                                              value: "事務員",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label:
                                                                "資深技術員",
                                                              value:
                                                                "資深技術員",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label: "組長",
                                                              value: "組長",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label: "儲備組長",
                                                              value: "儲備組長",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label: "工讀生",
                                                              value: "工讀生",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label: "實習生",
                                                              value: "實習生",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label: "按摩師",
                                                              value: "按摩師",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      errors[0]
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger ml-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            !(
                              _vm.appointment.ResumeType === "IDL" &&
                              _vm.appointment.SalaryType === "月薪"
                            )
                              ? _c(
                                  "tr",
                                  [
                                    _c(
                                      "td",
                                      { staticClass: "width-15 text-right" },
                                      [
                                        _c("span", { staticClass: "mark" }, [
                                          _vm._v("*"),
                                        ]),
                                        _vm._v("職等 "),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      { staticClass: "width-35" },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            rules: "required",
                                            name: "職等",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticClass: "w-100",
                                                        attrs: {
                                                          disabled:
                                                            !_vm.$Permission
                                                              .Appointment
                                                              .DLPermission
                                                              .IsValid,
                                                          placeholder: "請選擇",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.appointment
                                                              .Rank,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.appointment,
                                                              "Rank",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "appointment.Rank",
                                                        },
                                                      },
                                                      [
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "1",
                                                            value: "1",
                                                          },
                                                        }),
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "2",
                                                            value: "2",
                                                          },
                                                        }),
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "2.1",
                                                            value: "2.1",
                                                          },
                                                        }),
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "2.2",
                                                            value: "2.2",
                                                          },
                                                        }),
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "3",
                                                            value: "3",
                                                          },
                                                        }),
                                                        !(
                                                          _vm.appointment
                                                            .SalaryType ===
                                                          "時薪"
                                                        )
                                                          ? [
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "4",
                                                                  value: "4",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "5",
                                                                  value: "5",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "6",
                                                                  value: "6",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "6.3",
                                                                  value: "6.3",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "7",
                                                                  value: "7",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "7.3",
                                                                  value: "7.3",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "8",
                                                                  value: "8",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "8.3",
                                                                  value: "8.3",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "9",
                                                                  value: "9",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "9.3",
                                                                  value: "9.3",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "10",
                                                                  value: "10",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "10.3",
                                                                  value: "10.3",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "10.5",
                                                                  value: "10.5",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "10.7",
                                                                  value: "10.7",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "11",
                                                                  value: "11",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "11.3",
                                                                  value: "11.3",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "11.5",
                                                                  value: "11.5",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "12",
                                                                  value: "12",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "13",
                                                                  value: "13",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "13.3",
                                                                  value: "13.3",
                                                                },
                                                              }),
                                                            ]
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                    errors[0]
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger ml-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  errors[0]
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm.appointment.ResumeType === "DL" &&
                                    _vm.appointment.SalaryType === "月薪"
                                      ? [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "width-15 text-right",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mark" },
                                                [_vm._v("*")]
                                              ),
                                              _vm._v("月薪 "),
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "width-35" },
                                            [
                                              _c("ValidationProvider", {
                                                staticClass: "w-100",
                                                attrs: {
                                                  name: "月薪",
                                                  rules: {
                                                    regex: new RegExp(
                                                      /^([0-9,]+)$/
                                                    ),
                                                  },
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function ({
                                                        errors,
                                                      }) {
                                                        return [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model.trim",
                                                                value:
                                                                  _vm
                                                                    .appointment
                                                                    .BasicSalary,
                                                                expression:
                                                                  "appointment.BasicSalary",
                                                                modifiers: {
                                                                  trim: true,
                                                                },
                                                              },
                                                            ],
                                                            staticClass:
                                                              "form-control w-100",
                                                            attrs: {
                                                              disabled:
                                                                !_vm.$Permission
                                                                  .Appointment
                                                                  .DLPermission
                                                                  .IsValid,
                                                              type: "text",
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.appointment
                                                                  .BasicSalary,
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                )
                                                                  return
                                                                _vm.$set(
                                                                  _vm.appointment,
                                                                  "BasicSalary",
                                                                  $event.target.value.trim()
                                                                )
                                                              },
                                                              blur: function (
                                                                $event
                                                              ) {
                                                                return _vm.$forceUpdate()
                                                              },
                                                            },
                                                          }),
                                                          errors
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "text-danger",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        errors[0]
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      : _vm._e(),
                                    _vm.appointment.SalaryType === "時薪"
                                      ? [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "width-15 text-right",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mark" },
                                                [_vm._v("*")]
                                              ),
                                              _vm._v("時薪 "),
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "width-35" },
                                            [
                                              _c("ValidationProvider", {
                                                staticClass: "w-100",
                                                attrs: {
                                                  name: "時薪",
                                                  rules: {
                                                    regex: new RegExp(
                                                      /^([0-9,]+)$/
                                                    ),
                                                  },
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function ({
                                                        errors,
                                                      }) {
                                                        return [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model.trim",
                                                                value:
                                                                  _vm
                                                                    .appointment
                                                                    .HourSalary,
                                                                expression:
                                                                  "appointment.HourSalary",
                                                                modifiers: {
                                                                  trim: true,
                                                                },
                                                              },
                                                            ],
                                                            staticClass:
                                                              "form-control w-100",
                                                            attrs: {
                                                              disabled:
                                                                !_vm.$Permission
                                                                  .Appointment
                                                                  .DLPermission
                                                                  .IsValid,
                                                              type: "text",
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.appointment
                                                                  .HourSalary,
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                )
                                                                  return
                                                                _vm.$set(
                                                                  _vm.appointment,
                                                                  "HourSalary",
                                                                  $event.target.value.trim()
                                                                )
                                                              },
                                                              blur: function (
                                                                $event
                                                              ) {
                                                                return _vm.$forceUpdate()
                                                              },
                                                            },
                                                          }),
                                                          errors
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "text-danger",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        errors[0]
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.appointment.IdentityType === "IDL工讀生" ||
                            _vm.appointment.IdentityType === "按摩師"
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    { staticClass: "width-15 text-right" },
                                    [_vm._v("聘僱期間(起)")]
                                  ),
                                  _c(
                                    "td",
                                    { staticClass: "width-35" },
                                    [
                                      _c("el-date-picker", {
                                        staticClass: "w-100",
                                        attrs: {
                                          type: "date",
                                          "value-format": "yyyy-MM-dd",
                                          placeholder: "請選擇",
                                        },
                                        model: {
                                          value:
                                            _vm.appointment.EmploymentStart,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.appointment,
                                              "EmploymentStart",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "appointment.EmploymentStart",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "td",
                                    { staticClass: "width-15 text-right" },
                                    [_vm._v("聘僱期間(迄)")]
                                  ),
                                  _c(
                                    "td",
                                    { staticClass: "width-35" },
                                    [
                                      _c("ValidationProvider", {
                                        staticClass: "w-100",
                                        attrs: {
                                          name: "聘僱期間(迄)",
                                          rules: {
                                            notBeforeStartDate:
                                              _vm.appointment.EmploymentStart,
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c("el-date-picker", {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      type: "date",
                                                      "value-format":
                                                        "yyyy-MM-dd",
                                                      placeholder: "請選擇",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.appointment
                                                          .EmploymentEnd,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.appointment,
                                                          "EmploymentEnd",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "appointment.EmploymentEnd",
                                                    },
                                                  }),
                                                  errors[0]
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            !(
                              _vm.appointment.ResumeType === "IDL" &&
                              _vm.appointment.SalaryType === "月薪"
                            )
                              ? _c(
                                  "tr",
                                  [
                                    _c(
                                      "td",
                                      { staticClass: "width-15 text-right" },
                                      [
                                        _c("span", { staticClass: "mark" }, [
                                          _vm._v("*"),
                                        ]),
                                        _vm._v("工作時間 "),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        attrs: {
                                          colspan:
                                            _vm.appointment.WorkTimeType ===
                                            "一般工時"
                                              ? 1
                                              : 3,
                                        },
                                      },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            rules: "required",
                                            name: "工作時間",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-check form-check-inline",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.appointment
                                                                  .WorkTimeType,
                                                              expression:
                                                                "appointment.WorkTimeType",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-check-input",
                                                          attrs: {
                                                            type: "radio",
                                                            id: "WorkTimeType1",
                                                            value: "一般工時",
                                                          },
                                                          domProps: {
                                                            checked: _vm._q(
                                                              _vm.appointment
                                                                .WorkTimeType,
                                                              "一般工時"
                                                            ),
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.appointment,
                                                                "WorkTimeType",
                                                                "一般工時"
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "form-check-label",
                                                            attrs: {
                                                              for: "WorkTimeType1",
                                                            },
                                                          },
                                                          [_vm._v(" 一般工時 ")]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-check form-check-inline",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.appointment
                                                                  .WorkTimeType,
                                                              expression:
                                                                "appointment.WorkTimeType",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-check-input",
                                                          attrs: {
                                                            type: "radio",
                                                            id: "WorkTimeType2",
                                                            value: "特殊工時",
                                                          },
                                                          domProps: {
                                                            checked: _vm._q(
                                                              _vm.appointment
                                                                .WorkTimeType,
                                                              "特殊工時"
                                                            ),
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.appointment,
                                                                "WorkTimeType",
                                                                "特殊工時"
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "form-check-label",
                                                            attrs: {
                                                              for: "WorkTimeType2",
                                                            },
                                                          },
                                                          [_vm._v(" 特殊工時 ")]
                                                        ),
                                                      ]
                                                    ),
                                                    errors[0]
                                                      ? _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "text-danger ml-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  errors[0]
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm.appointment.WorkTimeType === "一般工時"
                                      ? [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "width-15 text-right",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mark" },
                                                [_vm._v("*")]
                                              ),
                                              _vm._v("班別 "),
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "width-35" },
                                            [
                                              _c("ValidationProvider", {
                                                attrs: {
                                                  rules: "required",
                                                  name: "班別",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function ({
                                                        errors,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "el-select",
                                                            {
                                                              staticClass:
                                                                "w-100",
                                                              attrs: {
                                                                filterable: "",
                                                                clearable: "",
                                                                placeholder:
                                                                  "請選擇",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .appointment
                                                                    .WorkShiftTypeGuid,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.appointment,
                                                                      "WorkShiftTypeGuid",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "appointment.WorkShiftTypeGuid",
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.shiftOptions,
                                                              function (shift) {
                                                                return _c(
                                                                  "el-option",
                                                                  {
                                                                    key: shift.Guid,
                                                                    attrs: {
                                                                      label:
                                                                        shift.Name,
                                                                      value:
                                                                        shift.Guid,
                                                                    },
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          ),
                                                          errors[0]
                                                            ? _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "text-danger ml-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        errors[0]
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.appointment.WorkShiftTypeGuid ===
                            "11111111-1111-1111-1111-111111111111"
                              ? [
                                  _c("tr", [
                                    _c(
                                      "td",
                                      { staticClass: "width-15 text-right" },
                                      [
                                        _c("span", { staticClass: "mark" }, [
                                          _vm._v("*"),
                                        ]),
                                        _vm._v("班別描述 "),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      { staticClass: "width-35" },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            rules: "required",
                                            name: "班別描述",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("el-input", {
                                                      staticClass: "w-100",
                                                      attrs: {
                                                        type: "textarea",
                                                        rows: 1,
                                                        maxlength: "20",
                                                        "show-word-limit": "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.appointment
                                                            .WorkShiftTypeDesc,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.appointment,
                                                            "WorkShiftTypeDesc",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "appointment.WorkShiftTypeDesc",
                                                      },
                                                    }),
                                                    errors[0]
                                                      ? _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "text-danger ml-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  errors[0]
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "td",
                                      { staticClass: "width-15 text-right" },
                                      [
                                        _c("span", { staticClass: "mark" }, [
                                          _vm._v("*"),
                                        ]),
                                        _vm._v("休息分鐘數 "),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      { staticClass: "width-35" },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            rules: "required",
                                            name: "休息分鐘數",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("el-input-number", {
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                      attrs: {
                                                        min: 0,
                                                        max: 999,
                                                        step: 1,
                                                        precision: 0,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.appointment
                                                            .BreakMinute,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.appointment,
                                                            "BreakMinute",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "appointment.BreakMinute",
                                                      },
                                                    }),
                                                    errors[0]
                                                      ? _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "text-danger ml-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  errors[0]
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      { staticClass: "width-15 text-right" },
                                      [
                                        _c("span", { staticClass: "mark" }, [
                                          _vm._v("*"),
                                        ]),
                                        _vm._v("每日工時 "),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      { staticClass: "width-35" },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            rules: "required",
                                            name: "每日工時",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("el-input-number", {
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                      attrs: {
                                                        min: 0,
                                                        max: 24,
                                                        step: 1,
                                                        precision: 0,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.appointment
                                                            .DailyWorkHour,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.appointment,
                                                            "DailyWorkHour",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "appointment.DailyWorkHour",
                                                      },
                                                    }),
                                                    errors[0]
                                                      ? _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "text-danger ml-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  errors[0]
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "td",
                                      { staticClass: "width-15 text-right" },
                                      [
                                        _c("span", { staticClass: "mark" }, [
                                          _vm._v("*"),
                                        ]),
                                        _vm._v("每週工時 "),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      { staticClass: "width-35" },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            rules: "required",
                                            name: "每週工時",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("el-input-number", {
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                      attrs: {
                                                        min: 0,
                                                        max: 168,
                                                        step: 1,
                                                        precision: 0,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.appointment
                                                            .WeeklyWorkHour,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.appointment,
                                                            "WeeklyWorkHour",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "appointment.WeeklyWorkHour",
                                                      },
                                                    }),
                                                    errors[0]
                                                      ? _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "text-danger ml-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  errors[0]
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                            _vm.appointment.WorkTimeType === "特殊工時"
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    { staticClass: "width-15 text-right" },
                                    [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v("出勤類型 "),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    { attrs: { colspan: "3" } },
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          rules: "required",
                                          name: "出勤類型",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.appointment
                                                            .SpecialWorkTimeType,
                                                        expression:
                                                          "appointment.SpecialWorkTimeType",
                                                      },
                                                    ],
                                                    attrs: {
                                                      id: "SpecialWorkTimeType1",
                                                      type: "radio",
                                                      value: "週一至週五",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.appointment
                                                          .SpecialWorkTimeType,
                                                        "週一至週五"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.appointment,
                                                          "SpecialWorkTimeType",
                                                          "週一至週五"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "mr-4",
                                                      attrs: {
                                                        for: "SpecialWorkTimeType1",
                                                      },
                                                    },
                                                    [_vm._v("週一至週五")]
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.appointment
                                                            .SpecialWorkTimeType,
                                                        expression:
                                                          "appointment.SpecialWorkTimeType",
                                                      },
                                                    ],
                                                    attrs: {
                                                      id: "SpecialWorkTimeType2",
                                                      type: "radio",
                                                      value: "約定工時",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.appointment
                                                          .SpecialWorkTimeType,
                                                        "約定工時"
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.appointment,
                                                          "SpecialWorkTimeType",
                                                          "約定工時"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: "SpecialWorkTimeType2",
                                                      },
                                                    },
                                                    [_vm._v("約定工時")]
                                                  ),
                                                  errors[0]
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-danger ml-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm.appointment.WorkTimeType === "特殊工時" &&
                            _vm.appointment.SpecialWorkTimeType === "約定工時"
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    { staticClass: "width-15 text-right" },
                                    [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v("約定週工時 "),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    { attrs: { colspan: "1" } },
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          rules: "required",
                                          name: "約定週工時",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c("el-input-number", {
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      min: 0,
                                                      max: 168,
                                                      step: 1,
                                                      precision: 0,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.appointment
                                                          .SpecialWeeklyHour,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.appointment,
                                                          "SpecialWeeklyHour",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "appointment.SpecialWeeklyHour",
                                                    },
                                                  }),
                                                  errors[0]
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-danger ml-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "td",
                                    { staticClass: "width-15 text-right" },
                                    [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v("約定月工時 "),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    { attrs: { colspan: "1" } },
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          rules: "required",
                                          name: "約定月工時",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c("el-input-number", {
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      min: 0,
                                                      max: 744,
                                                      step: 1,
                                                      precision: 0,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.appointment
                                                          .SpecialMonthlyHour,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.appointment,
                                                          "SpecialMonthlyHour",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "appointment.SpecialMonthlyHour",
                                                    },
                                                  }),
                                                  errors[0]
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-danger ml-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _c("tr", [
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v("其他說明"),
                              ]),
                              _c(
                                "td",
                                { attrs: { colspan: "3" } },
                                [
                                  _c("el-input", {
                                    staticClass: "w-100",
                                    attrs: {
                                      type: "textarea",
                                      rows: 5,
                                      maxlength: "400",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.appointment.Description,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.appointment,
                                          "Description",
                                          $$v
                                        )
                                      },
                                      expression: "appointment.Description",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          2
                        ),
                      ]),
                      _c("div", { staticClass: "button-wrap center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary mr-1",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.$router.back()
                              },
                            },
                          },
                          [_vm._v(" 返回 ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-success",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return handleSubmit(_vm.saveAppointmentForm)
                              },
                            },
                          },
                          [_vm._v(" 儲存 ")]
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }